import { PLAY_STORE_URL } from '@secretario/shared';
import { nativeBridge } from './secretarioNative.js';
import { isNativeShell } from './platform.js';

/**
 * Links da loja dentro do texto do Secretário ("[atualize](url)"). Só a página do
 * próprio app na Play ou na App Store vira link; qualquer outro colchete fica texto.
 */
const STORE_LINK =
  /\[([^\]\n]{1,40})\]\((https:\/\/play\.google\.com\/store\/apps\/details\?id=net\.secretarios\.app[^)\s]*|https:\/\/apps\.apple\.com\/[^)\s]+)\)/g;

export type TextPart = { text: string; url?: string };

export function splitStoreLinks(text: string): TextPart[] {
  const parts: TextPart[] = [];
  let last = 0;
  for (const match of text.matchAll(STORE_LINK)) {
    const start = match.index ?? 0;
    if (start > last) parts.push({ text: text.slice(last, start) });
    parts.push({ text: match[1]!, url: match[2]! });
    last = start + match[0].length;
  }
  if (last < text.length) parts.push({ text: text.slice(last) });
  return parts;
}

/** O texto sem a marcação do link (prévia da conversa, leitura em voz). */
export function stripStoreLinks(text: string): string {
  return text.replace(STORE_LINK, '$1');
}

export const isStoreUrl = (url: string) =>
  url.startsWith(PLAY_STORE_URL) || url.startsWith('https://apps.apple.com/');

/**
 * Atualizar: no app da Play, a atualização abre por dentro (folha da própria Play);
 * sem ela, a página do app na loja, no app da loja.
 */
export async function openStore(url: string = PLAY_STORE_URL): Promise<void> {
  if (await nativeBridge.startUpdate()) return;
  window.open(url, isNativeShell() ? '_system' : '_blank', 'noopener,noreferrer');
}
